import { ReferenceField, useRecordContext } from 'react-admin';
import { EmptyField } from '@/components/accessKeys/fields/EmptyField.jsx';
import CustomChipField from '@/components/global/fields/CustomChipField.jsx';
import { useDrawer } from '@/composables/useDrawer';
import { Palette } from '@/themes/themeOverrides/Palette';

const RetailChainChip = () => {
    const retailChain = useRecordContext();
    const { openDrawer } = useDrawer();

    if (!retailChain?.id || !retailChain?.name) {
        return <EmptyField />;
    }

    return <CustomChipField small shades color={Palette.violet.violet50} onClick={() => openDrawer(retailChain.id, 'retail-chain-show')} />;
};

RetailChainChip.propTypes = {};

export const BrandRetailChainField = () => {
    const record = useRecordContext();

    if (!record?.retailChainId) {
        return <EmptyField />;
    }

    return (
        <ReferenceField source='retailChainId' reference='retail-chain' link={false}>
            <RetailChainChip />
        </ReferenceField>
    );
};

BrandRetailChainField.propTypes = {};
